













































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import AdminBrands from "@/mixins/adminBrands";

// Types
import { IUser } from "@/models/users";
import { IUsersProviderMethods } from "@/models/providers/users";

@Component({
  components: {
    "user-brand-permissions": () =>
      import("@/components/app/admin/users/userBrandPermissions.vue"),
    "user-status-icon": () =>
      import("@/components/app/admin/users/userStatusIcon.vue")
  }
})
export default class ApiTokenListItem extends Mixins(AdminBrands) {
  // Inject

  @Inject({ from: "usersProviderMethods" })
  public readonly $usersMethods!: IUsersProviderMethods;

  // Props

  @Prop({ default: null })
  public user!: IUser;

  @Prop({ required: true })
  public isLoading!: boolean;

  // Data

  public isProcessing = false;

  // Computed

  public get whitelistIps() {
    return this.user.whitelisted_ips.split(",");
  }

  public get isActiveInactiveRoute() {
    return _.some(this.$route.matched, ({ name }) =>
      ["adminApiTokensActive", "adminApiTokensInactive"].includes(
        name as string
      )
    );
  }

  public get isTogglable() {
    return (
      !this.isProcessing &&
      !this.user.api_token_revoked &&
      this.$userCan("update_user")
    );
  }

  // Methods

  public async toggleActive(value) {
    try {
      this.isProcessing = true;
      await this.$usersMethods.changeActive(this.user.id, value);
      if (this.isActiveInactiveRoute) this.$bus.$emit("refreshUsersListing");
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.api_token_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
